import { render, staticRenderFns } from "./ContractorAboutForManager.vue?vue&type=template&id=84e449aa"
import script from "./ContractorAboutForManager.vue?vue&type=script&lang=ts"
export * from "./ContractorAboutForManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84e449aa')) {
      api.createRecord('84e449aa', component.options)
    } else {
      api.reload('84e449aa', component.options)
    }
    module.hot.accept("./ContractorAboutForManager.vue?vue&type=template&id=84e449aa", function () {
      api.rerender('84e449aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorAboutForManager.vue"
export default component.exports